<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12" class="pa-0 pt-4">
        <v-form ref="form">
          <v-textarea
            :disabled="queryParams"
            v-model="description"
            v-bind="form.description.props"
          ></v-textarea>
        </v-form>
      </v-col>
      <v-col v-if="!queryParams" cols="12" class="pa-0">
        <v-container fluid class="pa-0">
          <v-row no-gutters class="justify-space-between">
            <v-col
              class="pa-1"
              cols="3"
              v-for="(n, index) in totalImages"
              :key="index"
            >
              <v-card text tile class="checklist__single-image" white>
                <v-container fluid fill-height class=" pa-0">
                  <v-row
                    no-gutters
                    column
                    class="text-center justify-space-between fill-height"
                  >
                    <template
                      v-if="itemsCheckSaved[getSavedImageId(index)]"
                      class="text-center"
                    >
                      <v-icon
                        v-if="!queryParams"
                        class="checklist__icon-delete"
                        color="accent"
                        dense
                        size="16"
                        @click.prevent="deleteAndCleanImage(getImageId(index))"
                        >fas fa-plus</v-icon
                      >
                      <img
                        :src="thumbnailSavedImage(getSavedImageId(index))"
                        class="checklist__image"
                        alt="Image to upload"
                      />
                      <v-col
                        tag="div"
                        block
                        class="text-center checklist__image-text pa-0"
                        cols="12"
                        >{{ imagesTitles[index] }}</v-col
                      >
                    </template>
                    <template
                      v-else-if="itemsCheck[getImageId(index)]"
                      class="text-center"
                    >
                      <v-icon
                        v-if="!queryParams"
                        class="checklist__icon-delete"
                        color="accent"
                        dense
                        size="16"
                        @click.prevent="deleteAndCleanImage(getImageId(index))"
                        >fas fa-plus</v-icon
                      >
                      <img
                        :src="thumbnailImage(getImageId(index))"
                        class="checklist__image"
                        alt="Image to upload"
                      />
                      <v-col
                        tag="div"
                        block
                        class="text-center checklist__image-text pa-0"
                        cols="12"
                        >{{ imagesTitles[index] }}</v-col
                      >
                    </template>
                    <template v-else>
                      <v-icon
                        class="checklist__icon"
                        color="gray"
                        @click.prevent="uploadImage(getImageId(index))"
                        @onUpload="startImageResize"
                        @onComplete="endImageResize"
                        >fas fa-plus</v-icon
                      >
                      <template slot="loading">
                        <v-progress-circular
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                      </template>
                      <v-col
                        tag="div"
                        block
                        class="text-center checklist__image-text pa-0"
                        cols="12"
                      >
                        {{ imagesTitles[index] }}
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col v-else cols="12" class="pa-0">
        <v-carousel
          next-icon="keyboard_arrow_right"
          prev-icon="keyboard_arrow_left"
          hide-delimiters
          height="200px"
        >
          <v-carousel-item
            v-for="(image, index) in !queryParams
              ? checklistItemData.images
              : checklistQuery[$props.index].images"
            :key="index"
            reverse-transition="fade-transition"
            transition="fade-transition"
          >
            <a :href="image.thumb" target="_blank">
              <v-img contain :src="image.thumb" height="200px"></v-img>
            </a>
          </v-carousel-item>
        </v-carousel>
      </v-col>
      <v-row class="justify-end" v-show="!queryParams">
        <v-col cols="12" md="4" class="save-checklist__btn">
          <v-btn
            :disabled="!description.length"
            class="black--text"
            block
            color="accent"
            @click.stop="saveData()"
          >
            Guardar incidencia
          </v-btn>
        </v-col>
      </v-row>
    </v-row>
    <input
      v-show="false"
      ref="uploadcheck"
      :type="'file'"
      accept="image/jpeg,image/png"
      @change="resizeFileImage($refs.uploadcheck.files)"
    />
    <v-dialog v-model="imagesUploading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="subtitle-1">
          Subiendo imágenes de incidencia, por favor espere
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
            height="8"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { errorMessage } from "@/services/MessageService";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import { checkImagesMap } from "@/models/damage/CheckItemImages";
import Checklist from "@/models/damage";
import { ResizeImage } from "@/services/ResizeImage";
export default {
  data() {
    return {
      form: Checklist.getChecklistForm(),
      totalImages: 4,
      image_title: "Tomar foto",
      description: "",
      id: this.$route.params.id,
      colors: ["secondary", "yellow darken-2", "red", "orange"],
      imagesUploading: false,
      clickedID: ""
    };
  },
  async mounted() {
    if (this.queryParams) {
      this.description = this.checklistQuery[this.$props.index].description;
    }
  },
  props: [
    "name",
    "title",
    "checklistType",
    "checklistRef",
    "index",
    "queryParams"
  ],
  computed: {
    ...mapState("checklist", [
      "itemPath",
      "productRef",
      "eventRef",
      "checklistItemData",
      "checklistQuery",
      "itemsCheckSaved"
    ]),
    ...mapState("checklistImages", ["itemsCheck"]),
    imagesTitles() {
      return Object.keys(checkImagesMap);
    },
    checkItemPath() {
      return this.title.split(" ").join("");
    }
  },
  methods: {
    ...mapActions("checklist", ["getChecklistData"]),
    ...mapActions("transfers", ["saveChecklist"]),
    ...mapActions("checklistImages", [
      "addCheckItemImage",
      "deleteCheckItemImage",
      "getChecklistData"
    ]),
    uploadImage(id) {
      this.clickedID = id;
      this.$refs.uploadcheck.click();
    },
    async resizeFileImage(refImage) {
      if (refImage) {
        const config = {
          file: refImage[0],
          maxSize: 1080
        };
        const resizedImage = await ResizeImage(config);
        var imageObject = { id: this.clickedID, thumbnail: resizedImage };
        this.addCheckItemImage(imageObject);
      }
    },
    deleteImage() {
      this.items.pop();
    },
    async saveData() {
      const checklistData = {
        name: this.name,
        title: this.title,
        description: this.description,
        checked: true,
        incidence: true,
        images: this.itemsCheck,
        notApply: false
      };
      loaderStart();
      this.imagesUploading = true;
      try {
        if (!this.queryParams && this.checklistRef != undefined) {
          await this.saveChecklist({
            name: this.name,
            path: this.checkItemPath,
            checklist: checklistData,
            checklistRef: this.checklistRef,
            checklistType: this.checklistType
          });
          this.$emit("update-incidence", {
            index: this.$props.index,
            name: this.$props.name,
            title: this.$props.title
          });
        } else {
          errorMessage(
            "No se puede guardar checklist sin imagenes en la incidencia"
          );
        }
        this.imagesUploading = false;
        loaderDone();
      } catch (error) {
        errorMessage(
          "Ocurrió un error inesperado tratanto de guardar el checklist."
        );
        loaderDone();
      }
    },
    getSavedImageId(index) {
      return (
        this.checkItemPath + "-" + checkImagesMap[this.imagesTitles[index]]
      );
    },
    deleteAndCleanImage(id) {
      this.deleteCheckItemImage(id);
      this.$refs;
    },
    getImageId(index) {
      return (
        this.checkItemPath + "-" + checkImagesMap[this.imagesTitles[index]]
      );
    },
    thumbnailImage(title) {
      return this.itemsCheck[title].thumbnail;
    },
    thumbnailSavedImage(title) {
      return this.itemsCheckSaved[title].thumb;
    },
    startImageResize() {
      loaderStart();
    },
    endImageResize() {
      loaderDone();
    }
  }
};
</script>
<style scoped>
.checklist {
  border: 1px solid lightgray;
}
.checklist__single-image {
  border: 1px solid lightgray;
  border-radius: 2px;
  height: 90px;
  max-width: 200px;
  margin: 0 auto;
}
.checklist__icon {
  padding: 1rem;
  margin: 0 auto;
}
.checklist__icon-delete {
  padding: 0;
  margin: 0;
  height: 10px;
  width: 10px;
  right: 4px;
  top: 4px;
  transform: rotate(45deg);
  position: absolute;
}
.checklist__image {
  max-height: 103px;
  object-fit: contain;
  margin: 0;
  height: 80%;
  padding: 0 4px;
  width: 100%;
}
.checklist__image-text {
  background-color: gray;
  color: white;
  font-size: 12px;
  background-clip: content-box;
  max-height: 30px;
}
</style>
